export const dateFormats = [
  { value: 'YYYY-MM-DD', label: 'YYYY-MM-DD (ISO 8601)', example: '2026-05-09' },
  { value: 'MM/DD/YYYY', label: 'MM/DD/YYYY (US)', example: '05/09/2026' },
  { value: 'DD/MM/YYYY', label: 'DD/MM/YYYY (EU)', example: '09/05/2026' },
  { value: 'YYYY年MM月DD日', label: 'YYYY年MM月DD日 (CJK)', example: '2026年05月09日' },
] as const;

export type DateFormatValue = (typeof dateFormats)[number]['value'];
